module.exports = __webpack_public_path__ + "img/card5-bl4.d0442b3f.svg";